var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import success from "./../../assets/img/icons/success.svg";
import { connect } from 'react-redux';
var SuccessChangeProfile = function (props) {
    var message = props.message, clickOk = props.clickOk, darkTheme = props.darkTheme;
    return (_jsx("div", { children: _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', textAlign: 'center' } }, { children: [_jsx("img", { src: success, alt: "success", style: { marginBottom: '10px' } }), _jsx("p", __assign({ style: { fontSize: '14px', fontWeight: 400, marginBottom: '27px', color: darkTheme ? 'white' : 'rgba(0, 0, 0, 1)' } }, { children: message })), _jsx("div", __assign({ onClick: clickOk, className: "controls", style: { width: '100%' } }, { children: _jsx("button", { children: "\u041E\u043A" }) }))] })) }));
};
export default connect(function (state) { return ({
    darkTheme: state.application.get("darkTheme")
}); }, {})(SuccessChangeProfile);



// WEBPACK FOOTER //
// ./src/components/profile/SuccessChangeProfile.jsx